export default "__VITE_ASSET__ujVsnvsm__"